/**
 * GTM dataLayer push — ported from the legacy apps' utils/DataLayerEvents.js
 * (`pushToDataLayer`). Both the screens and spare-parts apps fire events into
 * `window.dataLayer` so the existing GTM container picks them up; the event
 * names/payloads below are kept byte-identical to legacy so the configured
 * tags/triggers keep working without GTM changes.
 *
 * Safe to call anywhere: no-ops during SSR/tests where `window` is absent,
 * and lazily creates the array GTM's snippet would otherwise own.
 */

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export function pushDataLayerEvent(event: string, payload: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })
}
